<template>
  <div>
    <!--    <ImprovementStatusPortlet></ImprovementStatusPortlet>-->
<!--    <portlet-->
<!--        :icon="'fal fa-lightbulb portlet-icon'"-->
<!--        :title="$t('improvements.improvements')"-->
<!--        :actions-block="true"-->
<!--        :fullheight="true"-->
<!--        class="portlet-pt-20"-->
<!--    >-->
<!--      <template slot="actionsBlock">-->
<!--        <button-->
<!--            class="btn btn-secondary"-->
<!--            @click="$router.push('/improvements/create')"-->
<!--        >-->
<!--          {{ $t("improvements.improvement.create") }}-->
<!--        </button>-->
<!--      </template>-->
<!--      <template slot="portletBody">-->
<!--        <div-->
<!--            class="row dataTable-filters orderlines-dt-filter mb-4 pb-3"-->
<!--            v-show="filterOpen"-->
<!--        >-->
<!--          &lt;!&ndash; filters hier &ndash;&gt;-->

<!--          &lt;!&ndash; assinged to filter &ndash;&gt;-->
<!--          <div class="col-md-4 col-xl-3 mb-3">-->
<!--            <label for="">{{ $t("improvements.filter.assignedTo.title") }}</label>-->
<!--            &lt;!&ndash; <div class="custom-control custom-radio">-->
<!--              <input-->
<!--                type="radio"-->
<!--                id="assignedTo-all"-->
<!--                name="assignedTo-all"-->
<!--                :value="''"-->
<!--                class="custom-control-input"-->
<!--                v-model="assignedTo"-->
<!--              />-->
<!--              <label-->
<!--                class="custom-control-label"-->
<!--                for="assignedTo-all"-->
<!--                >{{ $t("improvements.filter.assignedTo.showAll") }}</label-->
<!--              >-->
<!--            </div> &ndash;&gt;-->
<!--            <div class="custom-control custom-checkbox">-->
<!--              <input-->
<!--                  type="checkbox"-->
<!--                  id="assignedTo-me"-->
<!--                  name="assignedTo-me"-->
<!--                  class="custom-control-input"-->
<!--                  v-model="assignedTo"-->
<!--              />-->
<!--              <label class="custom-control-label" for="assignedTo-me">{{-->
<!--                  $t("improvements.filter.assignedTo.showMe")-->
<!--                }}</label>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; my improvements filter &ndash;&gt;-->
<!--          <div class="col-md-4 col-xl-3 mb-3">-->
<!--            <label for="">{{ $t("improvements.filter.myImprovements.title") }}</label>-->
<!--            <div class="custom-control custom-radio">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="myImprovement-all"-->
<!--                  name="myImprovement-all"-->
<!--                  :value="''"-->
<!--                  class="custom-control-input"-->
<!--                  v-model="customFilters[1].options.values"-->
<!--              />-->
<!--              <label-->
<!--                  class="custom-control-label"-->
<!--                  for="myImprovement-all"-->
<!--              >{{ $t("improvements.filter.myImprovements.showAll") }}</label-->
<!--              >-->
<!--            </div>-->

<!--            <div class="custom-control custom-radio">-->
<!--              <input-->
<!--                  type="radio"-->
<!--                  id="myImprovement-me"-->
<!--                  name="myImprovement-me"-->
<!--                  :value="getMe.uid"-->
<!--                  class="custom-control-input"-->
<!--                  v-model="customFilters[1].options.values"-->
<!--              />-->
<!--              <label class="custom-control-label" for="myImprovement-me">{{-->
<!--                  $t("improvements.filter.myImprovements.showMe")-->
<!--                }}</label>-->
<!--            </div>-->
<!--          </div>-->


<!--          &lt;!&ndash; status filter &ndash;&gt;-->
<!--          <div class="col-md-4 col-xl">-->
<!--            <div class="dropdown">-->
<!--              <label for="statusFilter">{{ $t('improvements.filter.status.title') }}</label>-->
<!--              <button id="statusFilter" class="btn btn-outline-filter dropdown-toggle" type="button">-->
<!--                <span>{{ $t('improvements.filter.status.title') }} ({{ customFilters[2].options.values.length }})</span>-->
<!--              </button>-->
<!--              <div class="dropdown-menu">-->
<!--                <div class="option-wrapper">-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'pending'"-->
<!--                           :value="'pending'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'pending'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.pending') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'denied'"-->
<!--                           :value="'denied'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'denied'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.denied') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'plan'"-->
<!--                           :value="'plan'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'plan'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.plan') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'do'"-->
<!--                           :value="'do'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'do'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.do') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'check'"-->
<!--                           :value="'check'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'check'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.check') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'act'"-->
<!--                           :value="'act'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'act'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.act') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                  <div class="custom-control custom-checkbox">-->
<!--                    <input :id="'done'"-->
<!--                           :value="'done'"-->
<!--                           class="custom-control-input"-->
<!--                           type="checkbox"-->
<!--                           v-model="customFilters[2].options.values"-->
<!--                    >-->
<!--                    <label :for="'done'" class="custom-control-label">-->
<!--                      <span>{{ $t('improvements.filter.status.done') }}</span>-->
<!--                    </label>-->
<!--                  </div>-->

<!--                </div>-->

<!--              </div>-->
<!--            </div>-->
<!--          </div>-->

<!--          &lt;!&ndash; end filters &ndash;&gt;-->
<!--        </div>-->


<!--        <div-->
<!--            class="row dataTable-filters orderlines-dt-filter mb-4 pb-3"-->
<!--            v-show="filterOpen"-->
<!--        >-->
<!--          <div v-if="showDaterangeHelp" class="col-12">-->
<!--            <div class="alert alert-info">-->
<!--              {{ $t("jobs.table.noRecordsFoundWithDateRange") }}-->
<!--              <button-->
<!--                  type="button"-->
<!--                  class="close"-->
<!--                  data-dismiss="alert"-->
<!--                  aria-label="Close"-->
<!--              >-->
<!--                <span aria-hidden="true">&times;</span>-->
<!--              </button>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-md-6 col-xl-6">-->
<!--            <label for="fromDate">{{ $t("ui.from") }}</label>-->

<!--            <datepicker-->
<!--                monday-first-->
<!--                use-utc-->
<!--                :language="en"-->
<!--                @selected="fromDateSelected"-->
<!--                :format="dateDisplay"-->
<!--                :disabledDates="getDisabledDatesFrom"-->
<!--                :value="customFilters[0].options.range.min"-->
<!--                id="fromDate"-->
<!--                input-class="form-control  "-->
<!--            />-->
<!--          </div>-->
<!--          <div class="col-md-6 col-xl-6">-->
<!--            <label for="toDate">{{ $t("ui.to") }}</label>-->
<!--            <datepicker-->
<!--                monday-first-->
<!--                use-utc-->
<!--                :disabledDates="getDisabledDatesTo"-->
<!--                :language="en"-->
<!--                :format="dateDisplay"-->
<!--                @selected="toDateSelected"-->
<!--                :value="customFilters[0].options.range.max"-->
<!--                id="toDate"-->
<!--                input-class="form-control "-->
<!--            />-->
<!--          </div>-->
<!--        </div>-->
        <Suggestions></Suggestions>
<!--        <data-tables-->
<!--            v-if="getConfig && getImprovements"-->
<!--            :tableClass="tableClass"-->
<!--            :columns="getColumns"-->
<!--            :rows="getImprovementsFiltered"-->
<!--            :renderTrigger="renderedComponent"-->
<!--            tableID="improvements-dt"-->
<!--            routerLinkClass="dt-router-link"-->
<!--            :tableInitOptions="tableInitOptions"-->
<!--            :customFilters="customFilters"-->
<!--            :deleteClass="'delete'"-->
<!--            :deleteFunction="deleteImprovement"-->
<!--            @rowSelected="rowSelected"-->
<!--        />-->
<!--      </template>-->
<!--    </portlet>-->
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import {dataTables} from "../../mixins/dataTables";
import {swalJobs} from "../../mixins/swalJobs";
import CustomTableFilters from "../../components/jobs/CustomTableFilters";
import Datepicker from "vuejs-datepicker";
import {en} from "vuejs-datepicker/dist/locale";
import icons from "@/mixins/improvements/icons";

import jobMethods from "../../mixins/jobs/jobMethods";
import timeCalc from "../../mixins/timeCalc";

import ImprovementStatusPortlet from "@/components/improvements/ImprovementStatusPortlet";
 import Suggestions from "@/components/workflowInterface/subViews/Suggestions.vue";
const statusSorting = {
  "created": 1,
  "pending": 2,
  "approved": 3,
  "plan": 4,
  "check": 5,
  "do": 6,
  "act": 7,
  "denied": 8,
  "done": 9
}
export default {
  name: "Improvements",
  mixins: [dataTables, swalJobs, jobMethods, timeCalc, icons],
  components: {
    Datepicker,
    CustomTableFilters,
    ImprovementStatusPortlet,
    Suggestions

  },
  data() {
    return {
      en: en,
      time: moment(),
      assignedTo: null,
      loadingJobs: true,
      filterOpen: true,
      filterOpenClass: "m-hide-lg",
      searchUid: "",
      searchActivity: "",
      showDaterangeHelp: false,
      picker: {
        startDate: new Date(),
        endDate: new Date(),
      },
      customFilters: [
        {
          filter: "dateRangeFilter",
          keyToFilter: "created_at",
          options: {
            range: {
              min: null,
              max: null,
            },
          },
        },

        {
          filter: 'arrayContains',
          keyToFilter: 'userId',
          options: {
            values: []
          }
        },
        {
          filter: 'arrayContains',
          keyToFilter: 'status',
          options: {
            values: []
          }
        },
      ],
    };
  },
  computed: {
    ...mapGetters("company", ["getConfig", "getActivities"]),
    ...mapGetters("improvements", ["getImprovement","getImprovements", "getMyUnseenAssignedImprovements"]),

    ...mapGetters("users", [
      "getSelectedWorkflow",
      "getMe",
      "getClaims",
      "getRunningJob",
      "getOrderlineWorkflowProduct",
      "getSelectedWorkflowLength",
    ]),
    getImprovementsFiltered() {
      let assignedTo = this.assignedTo
      return _.filter(this.getImprovements, improvement => {
        if (assignedTo) {
          if (improvement.assignedUser.uid) {
            return improvement.assignedUser.uid === this.getMe.uid
          }
        } else {
          return improvement
        }
      })
    },
    getColumns() {
      let self = this;
      let showDeleteButton = self.getClaims.admin;
      const me = this.getMe
      return [
        {
          data: null,
          name: " ",
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            let html = '' //`<a data-to="/improvements/${data.id}" class="action-icon dt-router-link"><i title="view" class="far fa-eye"></i></a>`
            html += data.assigneeHasNotSeen === me.id ? '<i class="far fa-bell" style="color: #00c9ff; font-size: 1.5rem; padding: 0 6px;"></i>' : ''

            if (data.title) {
              return html

            }
            return " ";
            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="view" class="far fa-eye"></i></a>`;
          },
        },
        {
          data: null,
          name: this.$t("improvements.table.likes"),
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data, type) {
            if (data.likes) {
              return data.likes.length;
            }
            if (type.sort) {
              return 0;
            }
            return "";
            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-eye"></i></a>`;
          },
        },
        {
          data: 'status',
          name: this.$t("improvements.improvement.status"),
          width: "1%",
          responsivePriority: 1,
          visible: true,
          render: function (data, type) {
            if (type == 'sort') {
              return statusSorting[data]
            }
            let icon = self.getIcon(data);
            return `<span  class="badge badge-primary  w-100" style="background:${icon.textColor}">${icon.text} </span>`;

            // return `<a data-to="/start-stop/${data.job.id}" class="action-icon dt-router-link"><i title="Aanpassen" class="far fa-eye"></i></a>`;

          }


        },
        {
          data: null,
          name: this.$t("improvements.table.improvement"),
          width: "70%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            return data.improvement ? data.improvement : data.title;
          },
        },
        {
          data: null,
          name: this.$t("improvements.table.assigned"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            if (data.assignedUser && data.assignedUser.name) {
              return data.assignedUser.name;
            } else {
              return null;
            }

          },
        },
        {
          data: "userName",
          name: this.$t("improvements.table.user"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
        },
        {
          data: "created_at",
          name: this.$t("improvements.table.date"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            return moment(data).format("DD-MM-YY");
          },
        },
        {
          data: "updated_at",
          name: this.$t("improvements.table.updated"),
          width: "2%",
          responsivePriority: 1,
          visible: true,
          render: function (data) {
            if (data != null) return moment(data).format("DD-MM-YY");
            else return "";
          },
        },
        {
          data: null,
          name: this.$root.$t('ui.options'),
          searchable: false,
          orderable: false,
          width: "5%",
          visible: true,
          responsivePriority: 1,
          render(data) {
            let str = '<a data-to="improvements/' + data.id + '" class="action-icon dt-router-link"><i title="' + self.$t('ui.edit') + '" class="far fa-edit"></i></a>'
            if (showDeleteButton) {
              str += `<a    data-id="${data.id}" class="delete action-icon   "><i class="far fa-trash-alt  delete"></i></a>`
            }
            return str
            //     '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="' + self.$t('ui.delete') + '" class="far fa-trash-alt delete"></i></a>'
            // return showDeleteButton
            //     ? `<a href='javascript:'  class="btn btn-danger delete-improvement text-center"><i class="fas fa-trash  delete-improvement"></i></a>`
            //     : "";
          },
        },
      ];
    },
    //@vuese
    // Gets disabled dates To
    getDisabledDatesTo() {
      return {
        to: new Date(this.customFilters[0].options.range.min), // Disable all dates up to specific date
      };
    }
    ,
    //@vuese
    // Gets disabled dates From
    getDisabledDatesFrom() {
      return {
        from: new Date(this.customFilters[0].options.range.max), // Disable all dates up to specific date
      };
    }
    ,
  },
  methods: {
    rowSelected(event) {
      console.log(event);
    },
    fromDateSelected(date) {
      this.customFilters[0].options.range.min = moment(date)
          .utc()
          .startOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );

      this.$store.dispatch("improvements/closeDBChannel").then(() => {
        this.openDBChannel();
      });
    },
    // @vuese
    //  sets the custom filter   date and saves this to local storage (is used to re hydrate the filter when refreshing the page)
    // @arg selected ``date``
    toDateSelected(date) {
      this.customFilters[0].options.range.max = moment(date)
          .utc()
          .endOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );

      this.$store.dispatch("improvements/closeDBChannel").then(() => {
        this.openDBChannel();
      });
    },
    deleteImprovement(data) {
      this.$swal
          .fire({
            title: this.$t("swal.delete.areyousure"),
            text:
                this.$t('improvements.improvement.deleteImprovement') + '. ' +
                this.$t("swal.delete.undone"),
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, delete it!",
          })
          .then((result) => {
            if (result.value) {
              this.$store.dispatch("improvements/delete", data.id).then(() => {
                this.swalToastSuccess(this.$t("ui.deleted"));
              });
            }
          });
    },
    //@vuese
    // Gets disabled dates To

    // @vuese
    // This event is needed to update the customfilters renderd via the customfilter component
    // THIS DOES NOT WORK WITH OTHER TYPE OF FILTERS YET
    // @arg `data` = values in the array
    //  @arg `idx` = index of the custom filter
    updateCustomFilter(data, idx) {
      this.customFilters[idx].options.values = data;
    },
    dateDisplay(date) {
      return moment(date).utc().format("DD/MM/YY");
    },
    /**
     * @vuese
     * Set date filters with new values from date range picker and filter table
     * @arg dateRange
     */
    updateDateRange(dateRange) {
      this.customFilters[0].options.range.min = moment(dateRange.startDate)
          .startOf("day")
          .toDate();
      this.customFilters[0].options.range.max = moment(dateRange.endDate)
          .endOf("day")
          .toDate();
      localStorage.setItem(
          "improvements-filter-state",
          JSON.stringify(this.customFilters)
      );
    },
    async openDBChannel() {
      this.$store.commit("setLoading", true);
      let where = [
        ["companyId", "==", this.getClaims.companyId],
        ["created_at", ">=", this.customFilters[0].options.range.min],
        ["created_at", "<=", this.customFilters[0].options.range.max],
      ];

      await this.$store.dispatch("improvements/openDBChannel", {where});

      // alert(this.$route.query.improvementId)
      if(this.$route.query.improvementId){
        let imrprovement = await this.getImprovement(this.$route.query.improvementId);
        window.$('#suggestionModal').data('parameters', {
          suggestion: imrprovement,
          // activeRun: this.activeRun,

        });
        window.$('#suggestionModal').modal('show');
      }else if (this.$route.query.create){
        window.$('#suggestionCreateModal').data('parameters', {
          // suggestion: imrprovement,
          // activeRun: this.activeRun,

        });
        window.$('#suggestionCreateModal').modal('show');
      }
      this.$store.commit("setLoading", false);
    },
  },
  async beforeRouteLeave(to, from, next) {
    await this.$store.dispatch("improvements/closeDBChannel");
    next();
  },
  async created() {

    let self = this;
    this.tableInitOptions.bStateSave = false;
    // this.tableInitOptions.order = [[2, "desc"]];
    this.tableInitOptions.serverSide = false
    let filterState = localStorage.getItem("improvements-filter-state");
    if (!filterState) {
      this.customFilters[0].options.range.min = moment()
          .utc()
          .startOf("year")
          .toDate();
      this.customFilters[0].options.range.max = moment()
          .utc()
          .endOf("year")
          .toDate();
    } else {
      let parsedFilters = JSON.parse(filterState);
      _.each(parsedFilters, (filter, index) => {
        if (filter.filter == "dateRangeFilter") {
          this.customFilters[index].options.range.min = new Date(
              parsedFilters[index].options.range.min
          );
          this.customFilters[index].options.range.max = new Date(
              parsedFilters[index].options.range.max
          );
        } else {
          this.customFilters.splice(index, 1, filter);
        }
      });
    }
    this.openDBChannel();
  },
};
</script>

<style scoped>
</style>